export default "__VITE_ASSET__2985ec4e__"